// Nuxt 2 paths whose Nuxt 4 page lives somewhere else. `:param` segments carry across.
// Nuxt 4's own routeRules and router.options.ts already cover `/settings` and the PascalCase plan tabs.
export const PATH_MAP = {
  '/settings/account-details': '/settings/account/details',
  '/settings/preferences': '/settings/account/preferences',
  '/settings/email': '/settings/account/mailboxes',
  '/settings/firm-details': '/settings/firm/details',
  '/settings/fca': '/settings/firm/fca',
  '/settings/security': '/settings/firm/ip-restrictions',
  '/settings/branding': '/settings/firm/branding',
  '/settings/mobile-app': '/settings/firm/mobile-app',
  '/settings/firm-notifications': '/settings/firm/notifications',
  '/settings/default-folders': '/settings/firm/default-folders',
  '/settings/default-folders/create': '/settings/firm/default-folders/create',
  '/settings/default-folders/:id': '/settings/firm/default-folders/:id',
  '/settings/factfinds': '/settings/firm/fact-find-templates',
  '/settings/factfinds/:id': '/settings/firm/fact-find-templates/:id',
  '/settings/groups': '/settings/firm/groups',
  '/settings/groups/:id': '/settings/firm/groups/:id',
  '/settings/workflows': '/settings/firm/workflows',
  '/settings/workflows/:id': '/settings/firm/workflows/:id',
  '/settings/webhooks': '/settings/integrations/webhooks',
  '/settings/webhooks/:id': '/settings/integrations/webhooks/:id',
  '/settings/addons': '/settings/integrations/addons',
  '/settings/external-connections': '/settings/integrations/external-connections',
  '/settings/client-statuses': '/settings/customisation/client-statuses',
  '/settings/custom-fields': '/settings/customisation/custom-fields',
  '/settings/tagging': '/settings/customisation/tags',
  '/settings/task-statuses': '/settings/customisation/task-statuses',
  '/settings/cases/task-default': '/settings/cases/tasks',
  '/settings/income-reconciliation/settings': '/settings/income-reconciliation/firm-settings',
  '/contacts/:id/conversations/:conversation': '/contacts/:id/conversations',
  '/circle/:id/conversations/:conversation': '/circle/:id/conversations',
  '/cases/:id/conversations/:conversation': '/cases/:id/conversations',
  '/cases/:id/profile': '/cases/:id',
  '/circle/:id/staff-members': '/circle/:id',
  '/contacts/:id/rq-embed': '/contacts/:id/rq-ratings',
  '/contacts/:id/seccl-embed': '/contacts/:id',
  // No Nuxt 4 page, so land on the dashboard rather than a 404.
  '/network': '/dashboard',
  '/network/finance': '/dashboard',
  '/note/:id': '/dashboard',
  '/404': '/dashboard',
};

// Login and logout have to complete on Nuxt 2's own session.
export const STAY_ON_NUXT_TWO = ['/auth', '/logout'];

const isUnder = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

const normalise = (path) => (path.length > 1 ? path.replace(/\/+$/, '') || '/' : path);

const compiledMap = Object.entries(PATH_MAP).map(([source, target]) => ({
  pattern: new RegExp(`^${source.replace(/:(\w+)/g, '(?<$1>[^/]+)')}$`),
  target,
}));

export function shouldStayOnNuxtTwo(path) {
  return STAY_ON_NUXT_TWO.some((prefix) => isUnder(normalise(path), prefix));
}

export function toMigrationPath(path) {
  const normalised = normalise(path);

  for (const { pattern, target } of compiledMap) {
    const match = normalised.match(pattern);
    if (match) return target.replace(/:(\w+)/g, (_, name) => match.groups[name]);
  }

  return normalised;
}
